<script setup lang="ts">
import { useGobyStore } from '~/stores/goby';
import { BASE_TITLE } from '~/utilities/constants';
import { walletModalEmitter } from '~/utilities/walletAdapter/walletModalEmitter';

useHead({
  title: `Mint on Chia ${BASE_TITLE}`,
  meta: [
    { property: 'og:title', content: `Mint on Chia ${BASE_TITLE}` },
    { property: 'twitter:title', content: `Mint on Chia ${BASE_TITLE}` },
    { name: 'twitter:card', content: 'summary_large_image' },
    { property: 'og:image', content: 'https://mintgarden.io/web-minting-banner.png' },
    { name: 'twitter:image', content: 'https://mintgarden.io/web-minting-banner.png' },
    {
      name: 'description',
      content: 'Mint your first NFT on Chia, directly from the browser.',
    },
  ],
});

const refresh = ref(false);

const gobyStore = useGobyStore();
await gobyStore.initialize();
watch(
  () => gobyStore.account,
  (account, oldAccount) => {
    if (!oldAccount && account) {
      gobyStore.loadProfiles();
    } else if (account && account !== oldAccount) {
      refresh.value = true;
      setTimeout(() => (refresh.value = false));
    }
  },
  { immediate: true }
);

const showWalletModal = () => {
  walletModalEmitter.showModal();
};
</script>
<template>
  <div>
    <Container>
      <div class="pt-8 sm:pt-16">
        <div class="text-center">
          <p
            class="text-4xl font-extrabold text-neutral-900 dark:text-neutral-50 sm:text-5xl sm:tracking-tight lg:text-5xl"
          >
            Mint on Chia
          </p>
        </div>
      </div>
      <div class="w-full">
        <div
          v-if="!gobyStore.account"
          class="mt-8 flex flex-col items-center gap-4 text-lg text-neutral-700 dark:text-neutral-200"
        >
          {{ gobyStore.account === undefined ? 'Loading...' : 'You have to connect your wallet.' }}
          <button
            v-if="gobyStore.account !== undefined"
            type="button"
            class="text-md betterhover:hover:shadow-card-hover hidden justify-center whitespace-nowrap rounded-full border border-transparent bg-emerald-600 px-4 py-2 font-semibold text-white transition duration-100 ease-in-out dark:text-black lg:flex"
            @click="showWalletModal"
          >
            Connect Wallet
          </button>
        </div>
        <MintSingleForm v-else-if="!refresh" />
      </div>
      <div v-if="!gobyStore.account" class="mt-32 text-center text-neutral-700 dark:text-neutral-200">
        Looking for the MintGarden Studio for bulk minting?
        <NuxtLink class="font-bold text-emerald-600" to="/mint/studio">Go here!</NuxtLink>
        <NuxtLink class="mx-auto flex w-full max-w-md" to="/mint/studio">
          <img src="/mintgarden_studio_screenshot.webp" alt="" />
        </NuxtLink>
      </div>
    </Container>
  </div>
</template>
